import { css } from "lit";

export const websiteStyles = css`
  p {
    font-size: 1.2rem;
  }

  a {
    color: rgb(65, 138, 207);
    text-decoration: none;
  }

  section {
    width: 100%;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;

    .content {
      position: relative;
      z-index: 2;
      width: 100%;
      max-width: 900px;
      padding: 2rem;
      box-sizing: border-box;
    }
  }

  .row {
    cursor: pointer;
    display: block;
    color: #fff;
    width: 100%;
    margin: 2px 0;
    padding: 10px 10px;
    background: linear-gradient(90deg, #181818, #242424);
    box-sizing: border-box;
    border: 1px solid #483e34;
    text-align: left;
    overflow: hidden;
    position: relative;
    font-size: 25px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    filter: saturate(70%);
    -webkit-filter: saturate(70%);
    -moz-filter: saturate(70%);
    -o-filter: saturate(70%);
    -ms-filter: saturate(70%);

    .cell {
      display: inline-block;
      margin-right: 20px;
      vertical-align: middle;
    }

    .cell.stats {
      float: right;
      text-align: right;
      font-size: 16px;
      margin-right: 0;
      margin-top: 5px;
    }    
  }

  .player-icon {
    width: 32px;
    height: 32px;
    border-radius: 16px;
    margin-right: 5px;
    vertical-align: middle;
  }

  .hero {
    background-size: cover;
    background-position: center 30%;
    background-repeat: no-repeat;
  }

  .hero::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }

  .hero-light::before {
    background: rgba(0, 0, 0, 0.1);
  }

  .hero-title {
    font-size: 3rem;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    color: #ffffff;
    line-height: 1.2;
  }

  .hero-subtitle {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    color: #f0f0f0;
    line-height: 1.4;
    text-transform: uppercase;
  }

  .hero-subtitle a {
    color: #83c9f5;
  }

  select {
    font-size: 15px;
    padding: 5px 0px;
    width: 140px;
    text-align: center;    
    border: 2px groove white;
    background:#1c1c1c;
    color: #FFF;
    border-radius: 5px;     
    margin-bottom: 3px;
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    .hide-mobile {
      display: none;
    }
    .row {
      .players {
        margin-top: 5px;
      }

      .cell.stats {
        font-size: 12px;
      }
    }

    select{
        width: calc(50% - 5px);
    }
  }
`;
